import React from "react";
import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const navLinkClass = ({ isActive }) =>
  `nav-link ${isActive ? "active fw-bold" : ""}`;

export default function MemberLayout() {
  const navigate = useNavigate();
  const { signOut, profile, isAdmin } = useAuth();

  return (
    <div style={{ minHeight: "100vh", background: "#f0f4f8" }}>
      <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/member/dashboard">
            PCF — My account
          </Link>
          <span className="navbar-text small me-2 d-none d-md-inline text-muted">
            {profile?.email}
          </span>
          <div className="navbar-nav ms-auto flex-row gap-2 align-items-center">
            {isAdmin && (
              <Link className="btn btn-sm btn-outline-primary" to="/admin/dashboard">
                Admin
              </Link>
            )}
            <Link className="btn btn-sm btn-outline-secondary" to="/">
              Website
            </Link>
            <button
              type="button"
              className="btn btn-sm btn-dark"
              onClick={async () => {
                await signOut();
                navigate("/", { replace: true });
              }}
            >
              Sign out
            </button>
          </div>
        </div>
      </nav>

      <div className="container-fluid">
        <div className="row">
          <aside
            className="col-md-3 col-lg-2 py-4 px-3 bg-white border-end"
            style={{ minHeight: "calc(100vh - 56px)" }}
          >
            <nav className="nav flex-column gap-1">
              <NavLink to="/member/dashboard" className={navLinkClass}>
                Events
              </NavLink>
              <NavLink to="/member/profile" className={navLinkClass}>
                Profile &amp; password
              </NavLink>
            </nav>
          </aside>
          <main className="col-md-9 col-lg-10 py-4 px-4">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
